import { createAxiosClient } from "@ntg/component-library/utilities";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { IODataMetadataCatalog } from "../../declarations/ODataExplorer";

const QUERY_KEY = ["odata-metadata"] as const;

const fetchMetadata = async (): Promise<IODataMetadataCatalog> => {
    const client = createAxiosClient("D365FO");
    const response = await client.get<IODataMetadataCatalog>("/ODataExplorer/metadata");
    return response.data;
};

const refreshMetadata = async (): Promise<IODataMetadataCatalog> => {
    const client = createAxiosClient("D365FO");
    const response = await client.post<IODataMetadataCatalog>("/ODataExplorer/metadata/refresh");
    return response.data;
};

export const useODataMetadata = () =>
    useQuery<IODataMetadataCatalog>({
        queryFn: fetchMetadata,
        queryKey: QUERY_KEY,
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: Infinity,
        gcTime: Infinity,
    });

export const useRefreshODataMetadata = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: refreshMetadata,
        onSuccess: (catalog) => {
            queryClient.setQueryData(QUERY_KEY, catalog);
        },
    });
};
